import { useState, useEffect } from "react";
import { sortByDate } from "../functions/sortByDate";
import { GetProposals } from "../functions/GetProposals";

export default function RecentProposals() {
  const [proposals, setProposals] = useState([]);

  useEffect(() => {
    (async () => {
      setProposals(await GetProposals());
    })();
  }, []);

  return (
    <>
      <div className="dashboard_heading">
        <b style={{ flex: 1, margin: "1em 0", fontSize: 22 }}>Name</b>
        <b style={{ flex: 1, margin: "1em 0", fontSize: 22 }}>Community</b>
      </div>
      {sortByDate(proposals).map((prop, i) => {
        return (
          <div key={i} className="dashboard_datarow">
            <p style={{ flex: 1, margin: "1em 0" }}>{prop.title}</p>
            <p style={{ flex: 1, margin: "1em 0" }}>{prop.community}</p>
          </div>
        );
      })}
    </>
  );
}
